"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerMetricDetailView = exports.MetricDetailView = void 0;
var React = require("react");
var EmptyTimeSeries_1 = require("./EmptyTimeSeries");
var formatting_1 = require("../formatting/formatting");
var utils_1 = require("../utils");
var Localize_1 = require("../../gen-src/Localize");
var MetricLegend_1 = require("./MetricLegend");
var DetailTimeSeries_1 = require("./DetailTimeSeries");
var widgets_1 = require("@tableau/widgets");
var metrics_engine_1 = require("@tableau/metrics-engine");
var WindowSwitcher_1 = require("./WindowSwitcher");
var Colors = widgets_1.TabStyles.Colors;
var DEFAULT_HEIGHT = '510px';
/**
 * The `MetricDetailView` is a fast, interactive timeseries display, designed for quick analysis of historical
 * trends.
 *
 * It displays an Interactive Line Chart with BAN, delta label, and hover tooltip.
 *
 * Responsively sized to fill the width of its container, with a default height of {@link DEFAULT_HEIGHT}
 */
var MetricDetailView = function (props) {
    var _a, _b;
    var data = props.data;
    if (!data) {
        return null;
    }
    // authoredWindow is tracked separately so that when the window switcher switches away from the authored window
    // it is still listed as an option
    var _c = React.useState(props.definition && (0, metrics_engine_1.getFirstWindow)(props.definition)), authoredWindow = _c[0], setAuthoredWindow = _c[1];
    var _d = React.useState(props.definition && (0, metrics_engine_1.getFirstWindowOrDefault)(props.definition)), selectedWindow = _d[0], setSelectedWindow = _d[1];
    // When the user starts editing the config, we want to restore the time series window to the authored window.
    // We also still want the window to change as the user edits the window while editing the config.
    React.useEffect(function () {
        // authoredWindow also needs to be updated so that the window switcher shows the correct options.
        var newAuthoredWindow = props.definition && (0, metrics_engine_1.getFirstWindowOrDefault)(props.definition);
        setAuthoredWindow(newAuthoredWindow);
        setSelectedWindow(newAuthoredWindow);
    }, [props.definition]);
    var definitionWithDateWindow = props.definition && selectedWindow && (0, metrics_engine_1.definitionWithWindow)(props.definition, selectedWindow);
    var windowSwitcherOptions = (0, WindowSwitcher_1.createWindowSwitcherOptions)((0, metrics_engine_1.dateTruncFromGranularity)((0, metrics_engine_1.getTimestampGranularity)(props.definition)), authoredWindow);
    var measureFormat = definitionWithDateWindow && (0, metrics_engine_1.getMeasureFormatString)(definitionWithDateWindow);
    var dataToRender = definitionWithDateWindow && (0, metrics_engine_1.materializeTable)(definitionWithDateWindow, data).unwrapOr([]);
    // The window switcher should be visible if the metric has more than one data point, NOT when the data
    // with the window applied has more than one data point.
    var shouldShowWindowSwitcher = props.flags.metricsWindowSwitcherEnabled && data.length > 1;
    return (React.createElement(InnerMetricDetailView, { data: dataToRender, 
        // definition may be undefined if it comes undefined from VPC, but InnerMetricDetailView handles that
        definition: definitionWithDateWindow, disabledWindowSwitcher: props.disabledWindowSwitcher, shouldShowWindowSwitcher: shouldShowWindowSwitcher, selectedDateWindow: selectedWindow, windowSwitcherOptions: windowSwitcherOptions, timeSeriesId: props.timeSeriesId, onWindowChange: setSelectedWindow, metricsReferenceLineEnabled: props.flags.metricsReferenceLineEnabled, metricColorIndicatorsEnabled: props.flags.metricsColorIndicatorsEnabled, measureFormat: measureFormat, lastUpdatedTimestamp: props.dataRefreshedTimestamp, testId: 'metric-detail', height: (_a = props.size) === null || _a === void 0 ? void 0 : _a.height, width: (_b = props.size) === null || _b === void 0 ? void 0 : _b.width }));
};
exports.MetricDetailView = MetricDetailView;
var InnerMetricDetailView = /** @class */ (function (_super) {
    __extends(InnerMetricDetailView, _super);
    function InnerMetricDetailView(props) {
        var _this = _super.call(this, props) || this;
        _this.onActivated = function (selectedValue) {
            _this.setState(function (state) {
                return {
                    selectedValue: selectedValue,
                };
            });
        };
        _this.renderComparisonDeltaAndTimestampArea = function (dateFormatter, measureAccessor, timestampAccessor, colorAccessor, comparisonMeasureAccessor, comparisonTimestampAccessor) {
            var _a;
            var delta = _this.comparisonDelta(measureAccessor, comparisonMeasureAccessor);
            var color = _this.props.metricColorIndicatorsEnabled
                ? (_a = (delta && colorAccessor(delta === null || delta === void 0 ? void 0 : delta.comparedPoint))) !== null && _a !== void 0 ? _a : metrics_engine_1.MetricsNeutralColor
                : metrics_engine_1.MetricsGrey;
            var iconProps = {
                altText: '',
                testId: 'metric-detail-delta-label',
                color: color,
                style: statusSymbolStyle,
                size: 20,
            };
            var colorIndicatorsFlag = {
                metricsColorIndicatorsEnabled: _this.props.metricColorIndicatorsEnabled,
            };
            var status = (0, metrics_engine_1.getStatus)(_this.props.definition, colorIndicatorsFlag, _this.state.selectedValue);
            var _b = !delta || !_this.props.definition
                ? { text: NON_BREAKING_SPACE, accessibilityText: '' }
                : (0, metrics_engine_1.formatComparisonTextForDetail)(delta, _this.props.definition, _this.props.measureFormat, status), text = _b.text, accessibilityText = _b.accessibilityText;
            var symbol = (0, utils_1.getIconForLabel)(iconProps, status, _this.props.definition, delta);
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { "data-tb-test-id": 'measure-delta', style: __assign(__assign({}, measureDeltaStyle), { color: color }), role: 'img', "aria-label": accessibilityText },
                    symbol,
                    text),
                React.createElement("div", { "data-tb-test-id": 'selected-point-timestamp', style: selectedTimeStyle, "aria-label": Localize_1.Messages.ariaLabelSelectedTime() }, _this.selectedTimestampOrTimeDelta(dateFormatter, delta, timestampAccessor, comparisonTimestampAccessor))));
        };
        _this.shouldRenderReferenceLine = function () {
            return _this.props.metricsReferenceLineEnabled ? (0, metrics_engine_1.shouldRenderFirstThresholdLine)(_this.props.definition) : false;
        };
        _this.renderTimeSeries = function (dateFormatter, measureAccessor, colorAccessor, timestampAccessor, comparisonMeasureAccessor, windowRange) {
            var _a;
            if (!(0, utils_1.isSingleNumberMetric)(_this.props.data) && timestampAccessor) {
                var lineStyle = (0, metrics_engine_1.getLineStyleForDefaultThresholdLine)(_this.props.definition);
                var comparisonLineInteractiveDot = !(lineStyle === null || lineStyle === void 0 ? void 0 : lineStyle.hidden) && (lineStyle === null || lineStyle === void 0 ? void 0 : lineStyle.interactive);
                return (React.createElement(DetailTimeSeries_1.ResizableDetailTimeSeries, { testId: "time-series", data: _this.props.data, dateFormatter: dateFormatter, onActivated: _this.onActivated, formatString: _this.props.measureFormat, timestampAccessor: timestampAccessor, measureAccessor: measureAccessor, comparisonAccessor: comparisonMeasureAccessor, shouldRenderReferenceLine: _this.shouldRenderReferenceLine(), comparisonLineStyle: (0, metrics_engine_1.getStylePropsForDefaultThresholdLine)(_this.props.definition), comparisonLineLabelAccessor: (0, metrics_engine_1.buildComparisonLineLabelAccessor)(_this.props.definition, _this.props.data), comparisonLineInteractiveDot: comparisonLineInteractiveDot, colorIndicatorsEnabled: (_a = _this.props.metricColorIndicatorsEnabled) !== null && _a !== void 0 ? _a : false, colorAccessor: colorAccessor, windowRange: windowRange, stringifiedDefinitionKey: JSON.stringify(_this.props.definition) }));
            }
            else {
                return React.createElement(EmptyTimeSeries_1.EmptyTimeSeries, null);
            }
        };
        _this.renderLegend = function (dateFormatter, timestampAccessor) {
            var _a;
            if (!(0, utils_1.isSingleNumberMetric)(_this.props.data) && timestampAccessor) {
                var dateRange = (_a = _this.getWindowRange()) !== null && _a !== void 0 ? _a : (0, metrics_engine_1.getDateRange)(_this.props.data);
                var showComparisonLine = _this.shouldRenderReferenceLine();
                var comparisonRange = showComparisonLine ? (0, metrics_engine_1.getComparisonDateRange)(_this.props.data) : undefined;
                return (dateRange && (React.createElement(MetricLegend_1.MetricLegend, { currentRange: dateRange, comparisonRange: comparisonRange, dateFormatter: dateFormatter, metricColorIndicatorsEnabled: _this.props.metricColorIndicatorsEnabled })));
            }
            else {
                return null;
            }
        };
        var initialValue = (0, utils_1.getBAN)(_this.props.data, _this.props.lastUpdatedTimestamp);
        _this.state = {
            selectedValue: initialValue,
            stringifiedDefinition: JSON.stringify(props.definition),
        };
        return _this;
    }
    InnerMetricDetailView.prototype.render = function () {
        var _a;
        var measureAccessor = this.props.definition && (0, metrics_engine_1.buildMeasureAccessor)(this.props.definition);
        if (!measureAccessor) {
            return null;
        }
        var timestampAccessor = this.props.definition && (0, metrics_engine_1.buildTimestampAccessor)(this.props.definition);
        var comparisonMeasureAccessor = this.props.metricsReferenceLineEnabled && this.props.definition
            ? (0, metrics_engine_1.buildFirstThresholdMeasureAccessor)(this.props.definition)
            : undefined;
        var comparisonTimestampAccessor = this.props.definition && (0, metrics_engine_1.buildFirstThresholdTimestampAccessor)(this.props.definition);
        var colorAccessor = (0, metrics_engine_1.buildColorAccessor)(this.props.definition);
        var banColor = this.props.metricColorIndicatorsEnabled ? metrics_engine_1.MetricsGrey : metrics_engine_1.MetricBlue;
        var dateFormatter = (0, metrics_engine_1.getDateFormatter)(this.props.definition);
        var windowRange = this.getWindowRange();
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { "data-tb-test-id": this.props.testId, style: __assign(__assign({}, this.props.style), { height: (_a = this.props.height) !== null && _a !== void 0 ? _a : DEFAULT_HEIGHT, width: this.props.width, display: 'flex', flexFlow: 'column' }) },
                React.createElement("div", { style: { flexGrow: 0 } },
                    React.createElement("div", { "data-tb-test-id": 'metric-detail-value', style: __assign(__assign({}, detailValueStyle), { color: banColor }), "aria-label": Localize_1.Messages.ariaLabelSelectedValue() }, (0, formatting_1.formatDataPointAsMetricNumber)(measureAccessor, this.state.selectedValue, this.props.measureFormat)),
                    this.renderComparisonDeltaAndTimestampArea(dateFormatter, measureAccessor, timestampAccessor, colorAccessor, comparisonMeasureAccessor, comparisonTimestampAccessor)),
                this.props.shouldShowWindowSwitcher && this.props.selectedDateWindow && (React.createElement(WindowSwitcher_1.WindowSwitcher, { selectedWindow: this.props.selectedDateWindow, options: this.props.windowSwitcherOptions, disabled: this.props.disabledWindowSwitcher, timeSeriesId: this.props.timeSeriesId, onWindowChange: this.props.onWindowChange })),
                React.createElement("div", { style: timeSeriesContainerStyle, role: 'tabpanel', id: this.props.timeSeriesId }, this.renderTimeSeries(dateFormatter, measureAccessor, colorAccessor, timestampAccessor, comparisonMeasureAccessor, windowRange)),
                this.renderLegend(dateFormatter, timestampAccessor))));
    };
    InnerMetricDetailView.getDerivedStateFromProps = function (nextProps, prevState) {
        var _a, _b;
        if (((_a = nextProps.lastUpdatedTimestamp) === null || _a === void 0 ? void 0 : _a.getTime()) !== ((_b = prevState.updatedTimestamp) === null || _b === void 0 ? void 0 : _b.getTime()) ||
            JSON.stringify(nextProps.definition) !== prevState.stringifiedDefinition) {
            var selectedValue = (0, utils_1.getBAN)(nextProps.data, nextProps.lastUpdatedTimestamp);
            return {
                selectedValue: selectedValue,
                updatedTimestamp: nextProps.lastUpdatedTimestamp,
                stringifiedDefinition: JSON.stringify(nextProps.definition),
            };
        }
        return {};
    };
    InnerMetricDetailView.prototype.comparisonDelta = function (measureAccessor, comparisonMeasureAccessor) {
        var latestValue = this.state.selectedValue;
        return latestValue ? (0, metrics_engine_1.computeMetricComparison)(latestValue, measureAccessor, comparisonMeasureAccessor) : undefined;
    };
    InnerMetricDetailView.prototype.getWindowRange = function () {
        var dateWindow = (0, metrics_engine_1.getFirstWindow)(this.props.definition);
        return dateWindow && this.props.data ? (0, metrics_engine_1.getWindowDateRange)(dateWindow, this.props.data) : undefined;
    };
    InnerMetricDetailView.prototype.selectedTimestampOrTimeDelta = function (dateFormatter, delta, timestampAccessor, comparisonTimestampAccessor) {
        var timestamp = this.state.selectedValue && timestampAccessor && timestampAccessor(this.state.selectedValue);
        var comparisonTimestamp = delta && comparisonTimestampAccessor && comparisonTimestampAccessor(delta.comparedPoint);
        if (!comparisonTimestamp || !timestamp) {
            return timestamp ? dateFormatter.banTimestamp(timestamp) : '';
        }
        return dateFormatter.comparisonWidget(timestamp, comparisonTimestamp);
    };
    InnerMetricDetailView.defaultProps = {
        timeSeriesId: 'timeseries-container',
    };
    return InnerMetricDetailView;
}(React.PureComponent));
exports.InnerMetricDetailView = InnerMetricDetailView;
var detailValueStyle = {
    marginTop: '12px',
    fontWeight: 300,
    fontSize: '48px',
    lineHeight: '1.2',
};
var selectedTimeStyle = {
    color: Colors.L9,
    fontSize: '14px',
    marginBottom: '12px',
    marginTop: '8px',
};
var measureDeltaStyle = {
    color: Colors.L9,
    display: 'flex',
    fontSize: '20px',
    marginBottom: '12px',
    marginTop: '8px',
    lineHeight: '1.2',
    alignItems: 'center',
};
var timeSeriesContainerStyle = {
    flex: '1 1',
    minHeight: '150px',
};
var statusSymbolStyle = {
    marginRight: '10px',
    marginBottom: '2px',
};
var NON_BREAKING_SPACE = '\xa0';
//# sourceMappingURL=MetricDetailView.js.map